import './Branding.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default function Branding({size="large", color=null, logoOnly=false}){
    return(
        <div className={(size) + " branding " + (color !== null ? color : "")}>
            <FontAwesomeIcon icon="fa-solid fa-envelope" /> 
            <div>{!logoOnly ? "PostShip" : ""}</div>
        </div>
    )
}